import React from 'react'
import PropTypes from 'prop-types'

import AddressForm from '../containers/AddressForm'
import AddressList from '../containers/AddressList'

import { initPageView } from '../../Analytics/common'

import '../styles/index.scss'

class Address extends React.Component {
  componentDidMount() {
    const {
      merchantCountry,
      fetchAddress,
      fetchAllCountries,
      fetchAllStates,
    } = this.props

    fetchAddress()
    fetchAllCountries()
    fetchAllStates(merchantCountry)

    initPageView()
  }

  render() {
    const { mode } = this.props
    return (
      <>
        {
        mode === 'list'
          ? <AddressList />
          : <AddressForm />
        }
      </>
    )
  }
}

Address.propTypes = {
  merchantCountry: PropTypes.string.isRequired,
  fetchAddress: PropTypes.func.isRequired,
  fetchAllCountries: PropTypes.func.isRequired,
  fetchAllStates: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
}

export default Address
